import Breadcrumbs from "@components/UI/Breadcrumbs";
import s from "./styles.module.sass";
import { MainPagesLayout } from "../../../containers/MainPagesLayout";
import { FeedBackForm } from "../../../features/FeedBackForm/view";
import NextLink from "@shared/wrappers/NextLink";

const mainContacts = [
	{
		id: 0,
		title: "Общие вопросы",
		email: "info@selfschool.ru",
	},
	{
		id: 1,
		title: "Служба поддержки",
		email: "support@selfschool.ru",
	},
	{
		id: 2,
		title: "Сотрудничество",
		email: "partnership@selfschool.ru",
	},
];

const ContactsView = () => {
	return (
		<MainPagesLayout>
			<Breadcrumbs
				links={[
					{
						id: 0,
						title: "Главная",
						to: "/",
					},
				]}
				currentPage="Контакты"
			/>

			<h1 className={s.title}>Контакты</h1>

			<ul className={s.mainContacts}>
				{mainContacts.map((mainContact) => {
					return (
						<li key={mainContact.id} className={s.mainContact}>
							<p>{mainContact.title}</p>
							<p className={s.mainContactEmail}>
								<NextLink href={`mailto:${mainContact.email}`}>{mainContact.email}</NextLink>
							</p>
						</li>
					);
				})}
			</ul>

			<FeedBackForm />

			<div className={s.restContacts}>
				<div className={s.restContactsBlock}>
					<h4 className={s.restContactsTitle}>Администратор платформы Selfschool — ООО «Парта»</h4>
					<p>Юридический адрес:</p>
					<br />
					<p>
						123112, г. Москва, вн. тер.г. муниципальный округ Пресненский, Пресненская наб., д. 6 стр. 2,
						помещ. 1/5
					</p>
				</div>
				<div className={s.restContactsBlock}>
					<h4 className={s.restContactsTitle}>Реквизиты</h4>
					<p>ОГРН 1215000031300 от 29.03.2021</p>
					<p>ИНН 5032327008</p>
					<p>КПП 770301001</p>
					<p>Р/с ДО «Тимура Фрунзе» в АО «АЛЬФА-БАНК»</p>
					<p>г Москва ИНН 7728168971</p>
					<p>БИК 044525593</p>
					<p>К/с 30101810200000000593</p>
				</div>
			</div>
		</MainPagesLayout>
	);
};

export default ContactsView;
